<button class="button is-primary is-outlined" on:click="showAudit()"><i class="fas fa-clipboard-check"></i></button>

<div class="modal {modalShowing ? 'is-active': ''} is-clipped">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Players Lineup Status</p>
            <button class="delete" aria-label="close" on:click="hideAudit()"></button>
        </header>
        <section class="modal-card-body">
            <table class='table is-striped is-fullwidth'>
                <thead>
                    <tr>
                        <th>Player</th>
                        <th>Innings Sitting</th>
                    </tr>
                </thead>
                <tbody>
                    {#each heatMap.hot as player, idx}
                    <tr>
                        <td>{player.name}</td>
                        <td>{player.inningCount}</td>
                    </tr>
                    {/each}
                    {#each heatMap.mild as player, idx}
                    <tr>
                        <td>{player.name}</td>
                        <td>{player.inningCount}</td>
                    </tr>
                    {/each}
                    {#each heatMap.cold as player, idx}
                    <tr>
                        <td>{player.name}</td>
                        <td>{player.inningCount}</td>
                    </tr>
                    {/each}
                </tbody>
            </table>
        </section>
    </div>
</div>

<script>
    export default {
        data() {
            return {
                modalShowing: false
            }
        },
        computed: {
            heatMap: ({ $activeRoster, $lineups }) => {
                let map = {}
                $activeRoster.forEach(function (player) {
                    map[player.last] = 0;
                });
                $lineups.forEach(function (lineup) {
                    $activeRoster.forEach(function (player) {
                        var found = false;
                        Object.keys(lineup).forEach(function (position) {
                            var positionPlayer = lineup[position];
                            if (positionPlayer.number == player.number) {
                                found = true;
                            }
                        });
                        if (!found) {
                            map[player.last]++;
                        }
                    });
                });
                let heatMap = {
                    hot: [],
                    mild: [],
                    cold: []
                };
                Object.keys(map).forEach(function (lastName) {
                    var el = {};
                    el.name = lastName;
                    el.inningCount = map[lastName];
                    if (el.inningCount > 2) {
                        heatMap.hot.push(el);
                    } else if (el.inningCount == 0) {
                        heatMap.cold.push(el);
                    } else {
                        heatMap.mild.push(el);
                    }
                });
                heatMap.hot.sort(function (a, b) {
                    return b.inningCount - a.inningCount;
                });
                heatMap.mild.sort(function (a, b) {
                    return b.inningCount - a.inningCount;
                });
                heatMap.cold.sort(function (a, b) {
                    return b.inningCount - a.inningCount;
                });
                return heatMap;
            }
        },
        methods: {
            showAudit() {
                this.set({ modalShowing: true });
            },
            hideAudit() {
                this.set({ modalShowing: false });
            }
        }
    }
</script>

<style>
    .tag {
        margin-right: 0.3em;
    }
</style>